namespace appn.views.data.index {

    class InitArgs {
        colCount: number = 0;
        colSettingPairs: string = emptyString;
        dFilter: string = emptyString;
        showDataTable: boolean = false;
        userList: Array<AppnSelectListItem> = [];
        selectedFormId: string = emptyString;
        selectedScreenKey: string = emptyString;
        selectedFormName: string = emptyString;
        selectedVersionNo: string = emptyString;
        dataTrash: string = emptyString;
        maxColLimit: number = 0;
    }

    let _initArgs: InitArgs;

    // This is a conversion DTO for JSON data coming over this way
    // if all goes well we will be able to fix it to use the IDT's directly soon
    interface ColSettingConfig {
        width: string;
        name: string;
        sortable: boolean;
    }

    let _dataTable: any = null;
    const _maxColReorderLimit: number = 50;

    export function init(args: InitArgs): void {
        _initArgs = args;

        appn.dataView.init();

        if (_initArgs.showDataTable) {
            createDataTable();

            appn.dateFilter.init(_initArgs.dFilter);
            
            addEvents();
            if (_initArgs.colCount > _maxColReorderLimit)
                appn.toast.notify(toast.Type.info, T('Column reordering is disabled because this entry has more than {0} columns.', _maxColReorderLimit));
            if (_initArgs.colCount >= _initArgs.maxColLimit)
                appn.toast.notify(toast.Type.info, T('Table columns beyond {0} have been hidden due to performance reasons.', _initArgs.maxColLimit));
        }
    }

    function addEvents() {

        $('#manageForm .card-tools button').click(function(event) {
            event.preventDefault();
            $(this).closest('.modal-dialog').find('.loadingOverlay-modal').show();

            if ($(this).val() === 'Trash') {
                // Hide any current ones
                appn.dialog.hide();

                const submitButton = $('#manageScreensDialog .card-header button[value="Manage_Trash"].btn-danger');
                const selectedItems = $('.selectRow:checked');

                const msgDetail = createTrashMessageFromTable(submitButton, selectedItems);

                const detail = elementBuilder.createElement('p', undefined, undefined, undefined, JSON.parse(msgDetail));
                const message = elementBuilder.createElement('p', undefined, undefined, undefined, T('You will have 30 days to restore from the Trash area before the item(s) are permanently deleted from the system.'));
                const confirmation = elementBuilder.createElement('p', 'trash-confirm-msg', undefined, undefined, T('Hit the <b>Trash</b> button to proceed.'));

                const buttonConfig = {
                    trash: {
                        label: '<span>' + T('Trash') + '</span>' + '<i class="fa fa-trash"></i>',
                        className: 'btn-success',
                        callback: function(result: any) {
                            if (!result)
                                return;

                            appn.dialog.showLoading();
                            appn.ajax.post({
                                url: _initArgs.dataTrash,
                                data: $('#manageForm').serialize(),
                                done: function() {
                                    _dataTable.fnDraw(false);
                                    appn.dialog.hide();
                                    appn.ui.disableElement($('#manageDataBtn'));
                                    toast.notify(toast.Type.info, T('Selected Form Entries successfully moved to Trash'));
                                },
                                fail: function() {
                                    appn.dialog.hide();
                                    $('#deleteOverlay').css('display', 'none');
                                    $('#deleteErrorMessage').css('display', 'inline');
                                    setTimeout(function() {
                                        $('#deleteErrorMessage').css('display', 'none');
                                    }, 5000);
                                    toast.notify(toast.Type.error, T('Unable to move selected Form Entries to Trash'));
                                },
                                always: function() {
                                    appn.dialog.hideLoading();
                                }
                            });
                        }
                    }
                };
                 
                appn.dialog.custom({
                    modalColor: 'modal-danger',
                    title: T('Move To Trash?'),
                    message: detail.outerHTML + message.outerHTML + '<br>' + confirmation.outerHTML,
                    className: 'appnGlobalConfirmTrash',
                    isTrashAction: true,
                    closeButton: true,
                    buttons: buttonConfig
                });

                return;
            }

            // Must be export
            appn.dialog.showLoading();

            // IsProtectData checkbox
            const currentCard = $(this).closest('.card');
            const isProtectFromCurrentCard = currentCard.find('.export-manage-isProtect-checkbox');
            if (utils.hasValue(isProtectFromCurrentCard)) {
                const currentValue = isProtectFromCurrentCard.is(':checked') as unknown as string;

                // Set the default hidden value that will be sent to the export controller
                $('#manageForm input[name="IsProtectData"]').remove();
                $('#manageForm').append(`<input name="IsProtectData" value="${currentValue}" type="hidden">`);
            }

            // EmbedImageLinks checkbox
            const embedImageLinksCurrentCard = currentCard.find('.export-manage-embedImageLinks-checkbox');
            if (utils.hasValue(embedImageLinksCurrentCard)) {
                const currentValue = embedImageLinksCurrentCard.is(':checked') as unknown as string;

                // Set the default hidden value that will be sent to the export controller
                $('#manageForm input[name="EmbedImageLinks"]').remove();
                $('#manageForm').append(`<input name="EmbedImageLinks" value="${currentValue}" type="hidden">`);
            }

            // Append IsProtect and EmbedImageLinks to form depending on which one was checked
            if (String($(this).val()).contains('Bulk'))
                dialog.bulkEntryExport.bulkExportSetValues(String($(this).val()));
            appn.ajax.post({
                url: 'Export/' + $(this).val(),
                data: $('#manageForm').serialize(),
                done: function() {
                    appn.notifications.updateNotificationTotal();
                    ui.showExportConfirmation('Bulk Entry');
                },
                always: function() {
                    appn.dialog.hide();
                    appn.dialog.hideLoading();
                }
            });

        });

        $(document).on('click', 'a[id^="viewGroup_"]', function (this: HTMLElement, e: Event) {
            e.preventDefault();
            return appn.ui.popup(this);
        });
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            scrollX: '100%',
            sDom: appn.dataTable.genSDom(3, 0, 2, '', 'RC'),
            iDisplayLength: 50,
            stateSave: _initArgs.colCount <= _maxColReorderLimit,
            stateSaveCallback: function(oSettings: any, oData: any) {
                localStorage.setItem(appn.dataTable.getCompositeStateCacheKey(oSettings, getSuffix()), JSON.stringify(oData));
            },
            stateLoadCallback: function(oSettings: any) {
                return JSON.parse(localStorage.getItem(appn.dataTable.getCompositeStateCacheKey(oSettings, getSuffix())));
            },
            oColReorder: {
                realtime: false,
                iFixedColumns: 4,
                reorderCallback: function() {
                    appn.dialog.singleEntryExport.init();
                    appn.dataTable.toggleOnRowChecked();
                }
            },
            autoWidth: true,
            bSort: true,
            sAjaxSource: 'Data/DataTable',
            fnServerData: function(data: any) {
                const appnDateFilterValue = appn.dateFilter.getStateOrDefault();
                data.push(appn.dataTable.getStateOrDefault('sCustom_0', _initArgs.selectedFormId),
                    { name: 'sCustom_1', value: appnDateFilterValue.type },
                    { name: 'sCustom_2', value: appnDateFilterValue.fromDate },
                    { name: 'sCustom_3', value: appnDateFilterValue.toDate },
                    appn.dataTable.getStateOrDefault('sCustom_4', $('#EntryId').val()),
                    appn.dataTable.getStateOrDefault('sCustom_5', $('#sCustom_5').val()));
            },
            aaSorting: [[1, IDTSortDir.desc]],
            aoColumns: getDtColConfiguration(),
            fnInitComplete: function() {
                if (_initArgs.userList.length > 0)
                    $('.dataTables_filter').prepend(elementBuilder.buildAppnSelect(_initArgs.userList, 'sCustom_5', 'saveMeState select2-noinit'));

                // Inject Screen Action buttons
                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'importEntriesBtn', buttonType: 'Import' }
                ], appn.requestUser.isSuperUserOrLoggedInAs);

                appn.actionButtons.renderNavbarActionButtons([
                    { buttonId: 'manageDataBtn', buttonType: 'Manage', isDataTableToggleBtn: true, buttonText: T('Manage Data') }
                ], true, true);

                if ($('.select-form-version'))
                    $('.dataTables_controls_start').last().append($('.select-form-version'));

                // Prpend the show button
                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));

                // Click event handler for importing form entries.
                $('#importEntriesBtn').click(function(e) {
                    e.preventDefault();
                    $('#importDialog').modal('show');
                });

                // Bind organise button
                $('#manageDataBtn').click(function(e) {
                    e.preventDefault();
                    if (!$(this).prop('disabled')) {
                        $('#manageForm input:not(.NoRemoval)').remove();

                        // Dynamically set the selected FormEntry Ids into Model.SelectedEntries
                        $('.selectRow:checked').each(function(index) {
                            $('#manageForm').append('<input type="hidden" name="SelectedEntries[' + index + ']" value="' + $(this)[0].id + '" />');
                        });

                        // Dynamically add Model.ItemType from parent
                        $('#manageForm').append(`<input type="hidden" name="SelectedFormId" value="${_initArgs.selectedFormId}" />`);
                        $('#manageForm').append(`<input type="hidden" name="SelectedScreenKey" value="${_initArgs.selectedScreenKey}" />`);
                        $('#manageForm').append(`<input type="hidden" name="SelectedFormName" value="${_initArgs.selectedFormName}" />`);
                        $('#manageForm').append(`<input type="hidden" name="SelectedVersion" value="${_initArgs.selectedVersionNo}" />`);
                        $('#manageForm').append('<input type="hidden" name="FromDate" value="' + $('#FromDate').val() + '" />');
                        $('#manageForm').append('<input type="hidden" name="ToDate" value="' + $('#ToDate').val() + '" />');
                        $('#manageForm').append('<input type="hidden" name="SelectedFileName" value="" />');
                        $('#manageForm').append('<input type="hidden" name="SelectedTemplate" value="" />');

                        $('#exportDialog').modal('show');

                        dialog.bulkEntryExport.init();
                    }
                    return false;
                });
             
                appn.dataTable.addSearchPlaceholder(T('Filter results where the selected forms <b>Answers</b> start with a keyword typed in here.'));
                appn.dialog.singleEntryExport.init();

                appn.saveMeState.init(function() {
                        $('#EntryId').val(appn.emptyString);
                        _dataTable.fnDraw(false);
                    },
                    function() {
                        $('#EntryId').val(appn.emptyString);
                        _dataTable.fnDraw(false);
                    }, '.dataTables_filter');

                select.init({ selector: '#sCustom_5', minimumResultsForSearch: '25' }) // Start displaying 'search' at 25 items
            },
            fnDrawCallback: function() {
                appn.dialog.singleEntryExport.init();

                // Click event handler for viewing media files
                $('td').on('click', 'a#viewMedia', function(event) {
                    event.preventDefault();
                    appn.dialog.viewMediaFromElement($(this));
                });
            }
        });
    }

    function getSuffix(): string {
        return '_' + ($('#SelectedScreenKey').val() as string).substring(0, 8) + '_' + ($('#SelectedVersionNo').val() as string);
    }

    function getDtColConfiguration(): Array<IDTColumnDefs> {
        const aoColumns: Array<IDTColumnDefs> = [];

        const columnSettingConfigs: Array<ColSettingConfig> = [];

        const columns = _initArgs.colSettingPairs.split('|');
        columns.forEach(function(column: string, index: number) {
            // Split out the separate settings and splice into our DTO
            const settings = column.split(',');
            const settingsConfig: ColSettingConfig = {
                sortable: JSON.parse(settings[0]),
                name: settings[1],
                width: settings[2]
            };
            columnSettingConfigs.push(settingsConfig);
        });

        columnSettingConfigs.forEach(function(columnSetting: ColSettingConfig, index: number) {
            //  Sort and order the columns
            // Special cases go first:
            if (columnSetting.name.toLowerCase() === appn.emptyString)
                aoColumns.push({
                    bSortable: columnSetting.sortable,
                    sWidth: columnSetting.width,
                    sName: columnSetting.name,
                    sDefaultContent: appn.emptyString
                } as IDTColumnDefs); // Checkboxes are non sortable
            else if (columnSetting.name.toLowerCase() === 'location')
                aoColumns.push({
                    bSortable: columnSetting.sortable,
                    sWidth: columnSetting.width,
                    sName: columnSetting.name,
                    sDefaultContent: appn.emptyString,
                    sType: IDTColumnType.html
                } as IDTColumnDefs); // Location is a link, thus making it sType html, will make it sortable
            else
                aoColumns.push({
                    bSortable: columnSetting.sortable,
                    sWidth: columnSetting.width,
                    sName: columnSetting.name,
                    sDefaultContent: appn.emptyString
                } as IDTColumnDefs);
        });
        return aoColumns;
    }

    function createTrashMessageFromTable(button: JQuery<HTMLElement>, selectedRows: any): string {
        let msg: string;
        button.attr('data-trashdetail', emptyString);

        const formName = $('#SelectedScreenKey option[selected]').text() as string;
        const formVersion = $('#SelectedVersionNo option[selected]').text() as string;

        if (selectedRows.length > 1) { // If we have multiple items
            const ul = elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
            selectedRows.each(function(index: number, selected: JQuery<HTMLElement>) {
                const name = $($(selected).closest('tr').find('td')[2]).text();
                const dateTime = $($(selected).closest('tr').find('td')[1]).clone()
                    .children()
                    .remove()
                    .end()
                    .text()
                    .trim();

                const item = T('<b>Entry by {0} ({1})</b>', name, dateTime);
                const li = elementBuilder.createElement('li', undefined, undefined, undefined, item);

                ul.appendChild(li);
            });

            msg = T('The following entries from the form <b>{0} (Version - {1})</b> will be moved to Trash and will no longer be available for use.', formName, formVersion) + ul.outerHTML;
        } else { // if we have a single item
            const name = $($(selectedRows[0]).closest('tr').find('td')[2]).text();
            const dateTime = $($(selectedRows[0]).closest('tr').find('td')[1]).clone()
                .children()
                .remove()
                .end()
                .text()
                .trim();

            msg = T('<b>Entry by {0} ({1})</b> from the form <b>{2} (Version - {3})</b> will be moved to Trash and will no longer be available for use.', name, dateTime, formName, formVersion);
        }

        const p = elementBuilder.createElement('p', undefined, undefined, undefined, msg);

        return JSON.stringify(p.outerHTML);
    }
}
